export enum ContactClassification {
  PERSONAL = 'Personal',
  BUSINESS = 'Business',
  UNKNOWN = 'Unknown',
  COMPANY = 'Company',
}
export enum PhoneClassification {
  PERSONAL = 'personalCell',
  HOME_PHONE = 'homePhone',
  HOME_FAX = 'homeFax',
  HOME_PAGER = 'homePager',
  WORK_MOBILE = 'workMobile',
  DESK = 'deskPhone',
  WORK_FAX = 'workFax',
  WORK_PAGER = 'workPager',
  OTHER = 'Other',
}
export enum WorkPhoneTypes {
  WORK_MOBILE = 'Work Mobile',
  DESK = 'Desk Phone',
  WORK_FAX = 'Work Fax',
  WORK_PAGER = 'Work Pager',
}
export const phoneClassificationToObject = {
  'Home Phone': 'homePhone',
  'Personal Cell': 'personalCell',
  'Home Fax': 'homeFax',
  'Home Pager': 'homePager',
  Other: 'other',
  'Work Mobile': 'workMobile',
  'Desk Phone': 'deskPhone',
  'Work Fax': 'workFax',
  'Work Pager': 'workPager',
};

export enum ShareStatus {
  NEW = 'New',
  UPDATES = 'Updates',
  DIFFERENCES = 'Differences',
  IGNORED = 'Ignored',
  ACCEPTED = 'Accepted',
}

export enum SharedType {
  DIRECT_SHARE = 'Direct Share',
  INDIRECT_SHARE = 'Indirect Share',
}

export enum CardTypes {
  VENDOR = 'VENDORS',
  CLIENT = 'CLIENTS',
  CUSTOMER_OF = 'CUSTOMER OF',
  BUSINESS_CARD = 'BUSINESS CARDS',
  PERSONAL_CONTACT_INFO = 'PERSONAL CONTACT INFO',
}

export enum ContactType {
  USER = 'User',
  ORG = 'Org',
  ALL = 'All',
  PLATFORM = 'Platform',
}

export enum ContactRealism {
  TEST = 'Test',
  REAL = 'Real',
  GHOST = 'Ghost',
  GHOST_TEST = 'GhostTest',
  MERGED = 'Merged',
}

export enum ContactCategory {
  SELF = 'Self',
  SHARED_IN = 'SharedIn',
  SHARED_OUT = 'SharedOut',
  SELF_CREATED = 'Self_Created',
}

export enum LegalNameType {
  MONONYM = 'Mononym',
  POLYNYM = 'Polynym',
}

export enum ContactVisibilityStatus {
  NONE = 'None',
  PUBLIC = 'Public',
  ANY_USER = 'AnyUser',
  FOLLOWEE = 'Followee',
  // commenting degrees as they are not in scope as on June 2024.
  // FIRST_DEGREE = '1st Degree',
  // SECOND_DEGREE = '2nd Degree',
  // THIRD_DEGREE = '3rd Degree',
  // THIRD_PLUS_DEGREE = '3rd+ Degree',
}
export enum AddContact {
  PREFERRED_NAME = 'preferredName',
  ORG_LEGAL_NAME = 'orgLegalName',
  LEGAL_NAME = 'legalName',
}

export enum OverrideSetting {
  POSITIVE = 'Positive Override',
  ALL = 'Override All',
  DISREGARD = 'Disregard',
}
export enum ContactEvents {
  // CONTACT_CREATED = 'ContactCreated',
  // CONTACT_UPDATED = 'ContactUpdated',
  // CONTACT_DELETED = 'ContactDeleted',
  // CONTACT_SHARED = 'ContactShared',
  CONTACT_MERGED = 'ContactMerged',
  CONTACT_DEMERGED = 'ContactDeMerged',
  CONTACT_QUICK_FILTERS = 'ContactQuickFilters',
  CONTACT_UPDATE_CARDS_FILTER = 'ContactUpdateCardsFilter',
  CONTACT_UPDATED = 'ContactUpdated',
  CONTACT_UPDATE_CONNECTION_FILTER = 'ConnectionFilters',
}

export enum ContactCardTypes {
  BUSSINESS = 'businessCards',
  CUSTOMER = 'customerCards',
  VENDOR = 'vendorCards',
  CLIENT = 'clientCards',
}

export enum ContactSortOptions {
  DATE_ADDED = 'createdDate',
  NAME = 'name',
}
export enum FilterMenuOptions {
  ContactType = 'Contact Type',
  BusinessCard = 'Business Card',
  CustomerCard = 'Customer Card',
  VendorCard = 'Vendor Card',
  ClientCard = 'Client Card',
  HasConnection = 'Has Connection',
  HiddenRecords = 'Hidden Records',
  IncludePublic = 'Include Public',
}

export enum ContactMatchType {
  SHARED_IN = 'SharedIn',
  CONTACT_DIRECTORY = 'ContactDirectory',
}

export enum CardNames {
  BusinessCard = 'businessCards',
  CustomerCard = 'customerCards',
  ClientCard = 'clientCards',
  VendorCard = 'vendorCards',
}
export enum ContactMatchSetting {
  IMMEDIATELY = 'immediately',
  DELAY = 'delay',
}

export enum ContactBreadCrumbActionIdentifiers {
  OpenInNewTab = 'OpenInNewTab',
  Compare = 'Compare',
  ProfileCard = 'ProfileCard',
  CloudMatch = 'CloudMatch',
}
